import { lazy } from "react";

export const CHUNK_RELOAD_STORAGE_KEY = "haastia.chunkReload";

// webpack names a failed script chunk ChunkLoadError; mini-css-extract tags a
// failed stylesheet chunk with this code.
const isChunkLoadError = (error) =>
  error?.name === "ChunkLoadError" || error?.code === "CSS_CHUNK_LOAD_FAILED";

// Reports whether this tab may reload for a missing chunk now: once, until a
// chunk loads again. Without storage there is no way to tell a second failure
// from the first, so it never reloads rather than risk a loop.
const claimChunkReload = () => {
  try {
    if (window.sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY)) return false;
    window.sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, "1");
    return true;
  } catch (_error) {
    return false;
  }
};

const clearChunkReload = () => {
  try {
    window.sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY);
  } catch (_error) {
    // Storage can be unavailable in privacy-restricted browsers.
  }
};

/**
 * React.lazy for code split out of the main bundle. A deploy replaces the
 * hashed files that code is fetched from, so a tab opened before it asks for
 * files that are gone the first time it needs them. Instead of the error
 * screen, the page reloads once onto the new build. If the files still can't
 * be fetched after that (the connection is down, say), the error goes through.
 */
export const lazyWithReload = (load) =>
  lazy(() =>
    load().then(
      (module) => {
        clearChunkReload();
        return module;
      },
      (error) => {
        if (!isChunkLoadError(error) || !claimChunkReload()) throw error;
        window.location.reload();
        // Keeps the loading state up until the reload replaces the page.
        return new Promise(() => {});
      },
    ),
  );
